<script>
export default {
  props: {
    height: {
      type: Number,
      required: false,
      default: 200
    }
  }
}
</script>

<template>
  <div class="dashboard-spinner-container" :style="{height: height+'px'}">
  <b-spinner style="color: #19A39C"></b-spinner>
  </div>
</template>

<style scoped lang="scss">
.dashboard-spinner-container {
  height: 100%;
   width: 100%;
   display: flex;
   align-items: center;
   justify-content: center;

}
</style>
